import { Download } from "lucide-react";
import { pdfUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const ExportButtons = ({ entity }) => (
  <div className="flex gap-1" data-testid={`export-${entity}`}>
    <Button asChild variant="outline" size="sm"><a href={pdfUrl(`/export/${entity}.xlsx`)} download data-testid={`export-${entity}-xlsx`}><Download className="h-3.5 w-3.5 mr-1" />Excel</a></Button>
    <Button asChild variant="outline" size="sm"><a href={pdfUrl(`/export/${entity}.csv`)} download data-testid={`export-${entity}-csv`}><Download className="h-3.5 w-3.5 mr-1" />CSV</a></Button>
  </div>
);
